import { Component } from 'preact'
import cx from 'classnames'

import { Image } from '../image'
import { Caption } from '../textNodes'
import CpdBadge from '../cpdBadge/cpdBadge'
import { capitalize, lowerCaseFirst, joinWithComma } from 'lib/textHelper'

export default class BurosferaVacancyAuthor extends Component {
  constructor(props) {
    super(props)
  }

  get authorOrganizationAndJob() {
    const authorJob = lowerCaseFirst(this.props.authorJob)

    return capitalize(joinWithComma([this.props.authorOrganization, authorJob]))
  }

  get isAnonymous() {
    return !this.props.authorName
  }

  get burosferaLink() {
    return `/burosfera/${this.props.authorEnglishName}`
  }

  render(props) {
    if (!props.isVisible) return null

    const className = cx(
      'burosferaVacancyForm-author',
      { is__visible: props.isVisible }
    )

    return (
      <div className={ className }>
        { !this.isAnonymous && props.authorAvatarUrl &&
          <Image
            src={ props.authorAvatarUrl }
            size={ [100, 100] }
            href={ this.burosferaLink }
            className='doubleHover'
            />
        }

        { !this.isAnonymous &&
          <Caption>
            <a className='doubleHover novisited' href={ this.burosferaLink }>
              <strong>{props.authorName}</strong>
            </a>
            <CpdBadge>{props.authorCpd}</CpdBadge>
            <br/>
            {this.authorOrganizationAndJob}
          </Caption>
        }

        { this.isAnonymous &&
          <div>
            <Image src='/assets/images/vacancy-user.svg' size={ [100, 100] }/>
            <Caption>
              <strong>Ваши имя и фамилия</strong>
              <br/>
              Компания, профессия
            </Caption>

            <Caption>
              После публикации вакансии здесь будут отображаться информация о вас
               и ваша фотография из Бюросферы
            </Caption>
          </div>
        }
      </div>
    )
  }
}
